import { Add, Close } from "@mui/icons-material";
import { IconButton, Stack, TableCell, Tooltip } from "@mui/material";
import { EmailTemplateSelect } from "components/emailing/EmailTemplateSelect/EmailTemplateSelect";
import { useTranslation } from "react-i18next";
import { EmailTemplateAssignmentTableCellProps } from "./EmailTemplateAssignmentTableCell.type";

export function EmailTemplateAssignmentTableCell({
  value,
  activityId,
  type,
  templates,
  isDisabled,
  onChange,
  onRemove,
}: EmailTemplateAssignmentTableCellProps) {
  const { t } = useTranslation("emailing");

  const noTemplatesToAssign = !templates.length;

  const handleChange = (templateId: number | null = null) => {
    onChange({
      triggerEvent: type,
      activityId,
      templateId,
    });
  };

  const handleAddTemplate = () => {
    const defaultTemplateId = templates[0]?.id;
    handleChange(defaultTemplateId);
  };

  return (
    <TableCell>
      {!noTemplatesToAssign && value?.templateId ? (
        <Stack direction={"row"} gap={1} alignItems={"center"}>
          <EmailTemplateSelect
            value={value.templateId}
            templates={templates}
            disabled={isDisabled}
            onChange={(templateId) => {
              handleChange(templateId);
            }}
          />
          <IconButton
            size="small"
            color={"error"}
            disabled={isDisabled}
            onClick={onRemove}
          >
            <Close fontSize={"small"} />
          </IconButton>
        </Stack>
      ) : (
        <Stack alignItems={"center"}>
          <Tooltip
            title={t(
              noTemplatesToAssign
                ? "assignEmail.noTemplatesToAssign"
                : "assignEmail.assignTemplate",
            )}
            placement="top"
          >
            <div>
              <IconButton
                size="small"
                color={"primary"}
                disabled={isDisabled}
                sx={{
                  backgroundColor: noTemplatesToAssign
                    ? "grey.100"
                    : "secondary.dark",
                }}
                onClick={handleAddTemplate}
              >
                <Add
                  fontSize={"small"}
                  color={
                    noTemplatesToAssign || isDisabled ? "disabled" : "secondary"
                  }
                />
              </IconButton>
            </div>
          </Tooltip>
        </Stack>
      )}
    </TableCell>
  );
}
